import React, { useEffect, useState } from "react";
import constusbanner from "../../Assests/back-header-1.png";
import { FaPhoneAlt, FaQuoteRight } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { Link } from "react-router-dom";
import handavideo from "../../Assests/Parth-Handa.mp4";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import Aos from "aos";

export default function AboutusPage() {
  const datatest = [
    {
      name: "VIKRAM SHARMA",
      text: `The team at Handa Realtor is exceptional! They introduced me to investment options in Dubai that I hadn’t considered before. Their understanding of both the Canadian and Dubai markets is unmatched. I’ve already recommended them to a few friends looking for global investment opportunities.`,
    },
    {
      name: "PRIYA PATEL",
      text: `I recently sold my home in Toronto with the help of Handa Realtor, and I couldn’t be happier with the experience! Parth and his team were incredibly professional and made the entire process stress-free. From pricing my property just right to negotiating with buyers, everything was handled with expertise. I highly recommend them to anyone looking to sell their property in Canada!`,
    },
    {
      name: "ANJALI VERMA",
      text: `As a first-time homebuyer in Canada, I was nervous about the entire process, but Handa Realtor made it so smooth and stress-free. Parth patiently answered all my questions, helped me find the perfect home within my budget, and guided me every step of the way. I’m so grateful for their expertise and support. Highly recommend them to anyone looking to buy a home!`,
    },
    {
      name: "AISHA KHAN",
      text: `Parth and his team were amazing to work with! I was initially hesitant about investing in Dubai properties, but their knowledge and professionalism put me at ease. They made the entire process seamless, and I feel confident about my decision. If you're in Canada and considering Dubai investments, Handa Realtor is the way to go.`,
    },
    {
      name: "RAJIV MEHTA",
      text: `I recently connected with Parth Handa through his Dubai investment campaign, and I’m so glad I did! He explained everything about the Dubai real estate market in a way that was easy to understand. The opportunities he presented were not only lucrative but also perfectly aligned with my investment goals. Highly recommend his expertise!`,
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div>
      <section
        className="contact-banner d-flex align-items-center justify-content-center text-center text-white"
        style={{
          backgroundImage: `url(${constusbanner})`,
        }}
      >
        <div className="overlay"></div>

        <div className="content w-100 container pt-5">
          <h1 className="text-start banner-title">About Us</h1>
        </div>
      </section>

      <section className="properties-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 ">
              <div className="d-flex justify-content-center ">
                <video
                  src={handavideo}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="rounded shadow "
                  style={{
                    objectFit: "cover",
                    display: "flex",
                    width: "70%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 mt-3 mt-md-4">
              <h2 className="text-start mb-4">About Parth Handa</h2>

              <p>
                I’m Parth Handa, a dedicated and passionate Sales Representative
                in the real estate industry. With a strong commitment to honesty
                and knowledge, I bring a fresh perspective and a diverse skill
                set to my clients.
              </p>

              <p>
                I proudly serve the communities of King, Stouffville, and
                Vaughan, extending my expertise to Caledon, Halton, Erin, and
                Oakville. My goal is to make your real estate journey as
                seamless and enjoyable as possible.
              </p>

              <p>
                Outside of work, I enjoy a variety of hobbies such as
                motorsports, skiing, kayaking, fishing, mountain biking,
                camping, and photography. These activities keep me grounded and
                provide a well-rounded approach to my professional life.
              </p>

              <p>
                My favorite quote, “The only limit to our realization of
                tomorrow is our doubts of today.” – Franklin D. Roosevelt
                reflects my philosophy of continuous improvement and dedication.
              </p>

              <p>
                With fluency in both English and Hindi, I am able to connect
                with a diverse range of clients. I am committed to understanding
                your unique needs and offering innovative solutions to help you
                achieve your real estate goals.
              </p>

              <p>
                I am here to guide you through the process of finding your
                perfect home, combining professionalism with a personal touch.
                Let me help you turn your real estate dreams into reality.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        className="properties-section"
        style={{ backgroundColor: "#000000" }}
      >
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-12">
              <p
                className="text-center text-uppercase text-light"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Explore Properties
              </p>
              <h2
                className="text-center text-light mb-4"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Client Feedback
              </h2>
              <Swiper
                modules={[Autoplay]}
                spaceBetween={20}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                loop={true}
                breakpoints={{
                  0: {
                    slidesPerView: 1, // mobile → 1 card
                  },
                  768: {
                    slidesPerView: 2, // tablet → 2 cards
                  },
                  992: {
                    slidesPerView: 3, // desktop → 3 cards
                  },
                }}
              >
                {datatest.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="card border-0 bg-light text-center h-100 p-4 rounded-3">
                      <h6 className="fw-semibold mb-3">{item.name}</h6>
                      <p className="small">"{item.text}"</p>
                      <div className="d-flex justify-content-center mt-auto">
                        <div
                          className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: "60px",
                            height: "60px",
                            fontSize: "20px",
                          }}
                        >
                          <FaQuoteRight />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-handa py-5">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-6"></div>

            <div className="col-md-6 text-dark">
              <p
                className="text-uppercase mb-2"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Let’s Find Your Dream Home
              </p>

              <h2
                className="mb-3"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Turn Your Homeownership Dream into Reality
              </h2>

              <p
                className="mb-4"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Buying a home is one of the most important decisions you’ll ever
                make— especially in fast-moving markets like Toronto, Whitby,
                Oshawa, Ajax, Pickering, and nearby areas.
              </p>

              <Link
                to="#"
                className="common_button"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                ENQUIRE NOW
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
